export default function Drop({ className, ...rest }: { className?: string }) {
  return (
    <svg
      {...rest}
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19 57.0213C19 61.4149 28.413 65 39.9758 65C51.5386 65 60.9516 61.4149 60.9516 57.0213C60.9516 55.4499 59.7692 53.9548 57.4966 52.6581C58.1722 53.4209 58.5101 54.2142 58.5101 55.0227C58.5101 56.9755 56.5599 58.8062 53.0281 60.1639C49.5424 61.5064 44.905 62.2387 39.9758 62.2387C35.0466 62.2387 30.4092 61.5064 26.9235 60.1639C23.3917 58.8062 21.4415 56.9755 21.4415 55.0227C21.4415 54.1989 21.7794 53.4056 22.455 52.6581C20.1977 53.9548 19 55.4499 19 57.0213Z"
        fill="currentColor"
      />
      <path
        d="M27.983 54.5193C27.983 55.6025 29.2422 56.6856 31.4381 57.4789C33.7107 58.3027 36.7511 58.7604 39.9758 58.7604C43.2005 58.7604 46.2255 58.3027 48.5135 57.4789C50.7094 56.6856 51.9686 55.6025 51.9686 54.5193C51.9686 53.4972 50.8476 52.475 48.8974 51.7123C49.527 52.2004 49.8648 52.7496 49.8648 53.3141C49.8648 55.3736 45.5192 56.9755 39.9758 56.9755C34.4324 56.9755 30.0868 55.3584 30.0868 53.3141C30.0868 52.7496 30.4092 52.2004 31.0388 51.7123C29.104 52.4903 27.983 53.4972 27.983 54.5193Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.7595 14.0001C39.288 13.9962 38.8209 14.2073 38.5165 14.611C31.8157 23.4974 27.4456 29.9885 27.4456 38.1499C27.4456 47.6327 34.4257 53.1868 41.1331 52.5599L41.1358 52.5596C47.9477 51.9109 52.3243 45.8074 52.059 40.1838C51.8259 35.3271 49.4516 32.3777 47.1885 29.5675C46.9454 29.2657 46.7037 28.9655 46.466 28.6647C44.0326 25.5851 41.6546 22.0973 41.2942 15.4437C41.2501 14.6294 40.5709 13.9987 39.7595 14.0001ZM38.6931 19.51C33.3725 26.8073 30.5167 31.9779 30.5167 38.1499C30.5167 46.0275 36.1273 49.9624 40.8442 49.5222C45.8861 49.0413 49.1866 44.4663 48.9912 40.3266C48.8071 36.4984 47.0475 34.2989 44.7615 31.4415C44.5295 31.1515 44.2921 30.8547 44.0503 30.5487C41.9065 27.8356 39.6755 24.6378 38.6931 19.51Z"
        fill="currentColor"
      />
    </svg>
  )
}
